/**
 * The evidence strip (memory tier 2, the Perplexity citation pattern): the
 * "cited by" list under a record's own provenance in the detail pane. The
 * citers are OTHER LOADED records whose edges point at this one — computed
 * client-side from neighbours data already fetched. The heading says
 * "in current view" ON PURPOSE: there is no reverse-edge server query wired
 * for this, so the strip is an observation about the loaded subgraph, never
 * a claim about the whole bank. Nothing citing it in the current view → the
 * strip is absent entirely (no empty speculation).
 */

/** One citer: a loaded record plus the edge it cites over. */
export interface MemoryCiter {
  id: string;
  title: string | null;
  /** The relation type on the citing edge (`answered`, `cites`, …), shown
   *  beside the title when the server disclosed it. */
  edgeType: string | null;
}

export function MemoryEvidenceStrip({ citers, onCite }: {
  citers: MemoryCiter[];
  /** Selects (and scrolls to) the citing record. */
  onCite: (id: string) => void;
}) {
  if (citers.length === 0) return null;
  return (
    <div className="vault-orgs__memory-evidence" data-testid="memory-evidence">
      <p className="vault-orgs__memory-evidence-head">
        {`Cited by ${citers.length === 1 ? '1 record' : `${citers.length} records`} — in current view`}
      </p>
      <ul className="vault-orgs__memory-evidence-list">
        {citers.map((c) => (
          <li key={c.id}>
            <button
              type="button"
              className="vault-orgs__memory-evidence-link"
              data-testid="memory-evidence-citer"
              onClick={() => onCite(c.id)}
            >
              <span className="vault-orgs__memory-evidence-title">{c.title || c.id}</span>
              {c.edgeType !== null && (
                <span className="vault-orgs__memory-evidence-edge">{c.edgeType}</span>
              )}
            </button>
          </li>
        ))}
      </ul>
    </div>
  );
}
